<p-message *ngIf="isOffline && !isGenericPatientLogin"
    [showTransitionOptions]="'0ms'"
    [hideTransitionOptions]="'0ms'"
    severity="warn" text="Data is incomplete - please logon as soon as possible">
</p-message>
<p-message *ngIf="isOffline && isGenericPatientLogin && selfRegisterPatientsCount !== 0"
    [showTransitionOptions]="'0ms'"
    [hideTransitionOptions]="'0ms'"
    severity="warn" [text]="selfRegisterPatientCountMessage">
</p-message>
<div pTooltip="You are offline"
     tooltipPosition="left"
     class="offline-indicator"
     *ngIf="isOffline" rte="gw">
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" rte="gx">
        <circle cx="10" cy="10" r="10" [attr.fill]="'red'"  rte="gy"/>
    </svg>
</div>